import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/trajectory')({
  beforeLoad: () => {
    throw redirect({ to: '/trends' });
  },
});
